module.exports = __webpack_public_path__ + "media/images/pc/top/icon-station_re-a09f777cc2bd13639590b7a82fd0aa4f.svg";